module.exports = __webpack_public_path__ + "img/noproduct.691b45dd.png";